import type { SVGProps } from 'react'
const SvgSySignOutSquare = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="m10.368 6.544 6.316-2.105A1 1 0 0 1 18 5.387v13.226a1 1 0 0 1-1.316.948l-6.317-2.105A2 2 0 0 1 9 15.559V8.442a2 2 0 0 1 1.367-1.898"
		/>
		<path d="M6.5 9a.5.5 0 0 0-.354.146l-2.5 2.5A.5.5 0 0 0 3.5 12a.5.5 0 0 0 .146.354l2.5 2.5a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.708L5.207 12.5H14a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5H5.207l1.647-1.646a.5.5 0 0 0 0-.708A.5.5 0 0 0 6.5 9" />
	</svg>
)
export default SvgSySignOutSquare
